module.exports = __webpack_public_path__ + "img/insurreport-recent-works.380d5258.png";